import { render, staticRenderFns } from "./TablePedidosOffline.vue?vue&type=template&id=23f2fb1d&"
import script from "./TablePedidosOffline.vue?vue&type=script&lang=js&"
export * from "./TablePedidosOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports